import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AlertTriangle, Loader2 } from "lucide-react";

export default function DeactivateUserDialog({
  target,
  stage,
  setStage,
  emailConfirm,
  setEmailConfirm,
  emailMatches,
  busyId,
  closeDeactivate,
  confirmDeactivate,
}) {
  return (
    <Dialog open={!!target} onOpenChange={(o) => (!o ? closeDeactivate() : null)}>
      <DialogContent data-testid="deactivate-dialog">
        {stage === 1 ? (
          <>
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <AlertTriangle className="h-5 w-5 text-destructive" />
                Konto deaktivieren?
              </DialogTitle>
              <DialogDescription>
                Möchten Sie das Konto von{" "}
                <span className="font-medium text-foreground">{target?.company || target?.email}</span>{" "}
                wirklich deaktivieren? Der Nutzer kann sich nicht mehr anmelden. Alle Daten bleiben
                erhalten und können jederzeit reaktiviert werden.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <Button variant="outline" onClick={closeDeactivate} data-testid="deactivate-cancel">
                Abbrechen
              </Button>
              <Button variant="destructive" onClick={() => setStage(2)} data-testid="deactivate-continue">
                Weiter
              </Button>
            </DialogFooter>
          </>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle>Deaktivierung bestätigen</DialogTitle>
              <DialogDescription>
                Geben Sie zur endgültigen Bestätigung die E-Mail-Adresse des Nutzers ein:{" "}
                <span className="font-medium text-foreground">{target?.email}</span>
              </DialogDescription>
            </DialogHeader>
            <Input
              value={emailConfirm}
              onChange={(e) => setEmailConfirm(e.target.value)}
              placeholder={target?.email}
              autoComplete="off"
              data-testid="deactivate-email-input"
            />
            <DialogFooter>
              <Button variant="outline" onClick={closeDeactivate} data-testid="deactivate-cancel-2">
                Abbrechen
              </Button>
              <Button
                variant="destructive"
                onClick={confirmDeactivate}
                disabled={!emailMatches || busyId === target?.id}
                data-testid="deactivate-confirm"
              >
                {busyId === target?.id ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                  "Endgültig deaktivieren"
                )}
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
